import(/* webpackMode: "eager" */ "/codebuild/output/src348838661/src/main_website/src/app/people/page.tsx");
